module.exports = __webpack_public_path__ + "static/img/5.f2d668f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/5.png
// module id = ZuzW
// module chunks = 0